module.exports = {"411721001":"柏城街道","411721002":"柏亭街道","411721003":"柏苑街道","411721101":"五沟营镇","411721102":"权寨镇","411721103":"师灵镇","411721104":"出山镇","411721105":"盆尧镇","411721106":"嫘祖镇","411721201":"重渠乡","411721203":"人和乡","411721204":"宋集乡","411721205":"谭店乡","411721208":"芦庙乡","411721209":"杨庄乡","411721210":"专探乡","411721211":"二郎乡","411721212":"蔡寨回族乡","411721213":"焦庄乡","411721500":"老王坡农场","411721501":"产业集聚区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411721.json
// module id = 1539
// module chunks = 0